module.exports = __webpack_public_path__ + "img/case-ct_compactvanguards_empty.e8798d2.png";